(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4361],{

/***/ 29099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ PageContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atomic/PageContainer/PageContainer.tsx

var PageContainer = function(param) {
    var children = param.children, _containerClass = param.containerClass, containerClass = _containerClass === void 0 ? "" : _containerClass;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
        className: "container container--body ".concat(containerClass),
        children: children
    });
};

;// CONCATENATED MODULE: ./components/atomic/PageContainer/index.ts



/***/ }),

/***/ 45917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* reexport */ StickyButtons; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-awesome-reveal/dist/index.js + 1 modules
var dist = __webpack_require__(81277);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./node_modules/react-tooltip/dist/react-tooltip.min.mjs
var react_tooltip_min = __webpack_require__(42444);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/Configurator/StickyButtons/sticky-buttons.module.scss
var sticky_buttons_module = __webpack_require__(54047);
var sticky_buttons_module_default = /*#__PURE__*/__webpack_require__.n(sticky_buttons_module);
// EXTERNAL MODULE: ./components/styleguide/VehicleImage/index.ts + 2 modules
var VehicleImage = __webpack_require__(52733);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./store/selectors/vehicle.js
var selectors_vehicle = __webpack_require__(20548);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/styleguide/Configurator/StickyButtons/StickyButtons.tsx












var StickyButtons = function(param) {
    var imageStatus = param.imageStatus, setImageStatus = param.setImageStatus, openSelector = param.openSelector, setActiveSection = param.setActiveSection, activeSection = param.activeSection, vehicle = param.vehicle;
    var ref, ref1, ref2, ref3;
    var isMobile = (0,react_responsive.useMediaQuery)({
        maxWidth: 991
    });
    var paintOptions = (0,es/* useSelector */.v9)(selectors_vehicle/* selectPaintOptions */.eJ);
    var onClickColourOptions = function() {
        setActiveSection(constants/* constants.configPageSections.COLOUR_OPTIONS */._G.configPageSections.COLOUR_OPTIONS);
        setImageStatus(constants/* constants.imageStatus.EXTERIOR */._G.imageStatus.EXTERIOR);
    };
    var onClickExteriorOption = function() {
        setActiveSection(constants/* constants.configPageSections.OVERVIEW */._G.configPageSections.OVERVIEW);
        setImageStatus(constants/* constants.imageStatus.EXTERIOR */._G.imageStatus.EXTERIOR);
    };
    var onClickInteriorOption = function() {
        setActiveSection(constants/* constants.configPageSections.OVERVIEW */._G.configPageSections.OVERVIEW);
        setImageStatus(constants/* constants.imageStatus.INTERIOR */._G.imageStatus.INTERIOR);
    };
    (0,react.useEffect)(function() {
        if (!isMobile && imageStatus === constants/* constants.imageStatus.INTERIOR_FULL_SCREEN */._G.imageStatus.INTERIOR_FULL_SCREEN) {
            setImageStatus(constants/* constants.imageStatus.INTERIOR */._G.imageStatus.INTERIOR);
        }
    }, [
        imageStatus,
        isMobile,
        setImageStatus
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-image-status": imageStatus,
        "data-is-mobile": isMobile,
        className: "config-page__sticky-button ".concat((sticky_buttons_module_default())["sticky-buttons"], " ").concat(imageStatus === constants/* constants.imageStatus.INTERIOR_FULL_SCREEN */._G.imageStatus.INTERIOR_FULL_SCREEN && isMobile ? " config-page__sticky-button--right" : ""),
        "data-is-selector-open": openSelector === "" ? "false" : "true",
        children: [
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_tooltip_min/* Tooltip */.u, {
                place: "right",
                className: (sticky_buttons_module_default()).tooltip,
                classNameArrow: (sticky_buttons_module_default())["tooltip-arrow"],
                id: "sticky-buttons-tooltip"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Fade */.pT, {
                className: (sticky_buttons_module_default()).left,
                triggerOnce: true,
                delay: 300,
                children: [
                    !isMobile && activeSection === constants/* constants.configPageSections.COLOUR_OPTIONS */._G.configPageSections.COLOUR_OPTIONS && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        "data-tooltip-id": "sticky-buttons-tooltip",
                        "data-tooltip-content": "Back to config",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            onClick: function() {
                                return setActiveSection(constants/* constants.configPageSections.OVERVIEW */._G.configPageSections.OVERVIEW);
                            },
                            label: "",
                            icon: "X",
                            size: system/* Size.Large */.$u.Large,
                            theme: system/* Theme.dark */.Q2.dark,
                            hierarchy: Button/* ButtonHierarchy.Filled */.B.Filled,
                            id: "back-to-config"
                        })
                    }, "back-to-config"),
                    imageStatus === constants/* constants.imageStatus.INTERIOR */._G.imageStatus.INTERIOR && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (sticky_buttons_module_default()).sideview,
                        onClick: function() {
                            return setImageStatus(constants/* constants.imageStatus.EXTERIOR */._G.imageStatus.EXTERIOR);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleImage/* VehicleImage */.o, {
                            alt: "",
                            className: (sticky_buttons_module_default()).thumbnail,
                            height: 120,
                            width: 172,
                            imagePath: (ref1 = vehicle === null || vehicle === void 0 ? void 0 : (ref = vehicle.gallery) === null || ref === void 0 ? void 0 : ref.images.filter(function(i) {
                                return i.angle === "sideview";
                            })) === null || ref1 === void 0 ? void 0 : ref1[0].path,
                            backupImagePath: "",
                            type: "DEFAULT"
                        })
                    }),
                    imageStatus === constants/* constants.imageStatus.EXTERIOR */._G.imageStatus.EXTERIOR && activeSection === constants/* constants.configPageSections.OVERVIEW */._G.configPageSections.OVERVIEW && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        "data-tooltip-id": "sticky-buttons-tooltip",
                        "data-tooltip-content": "Colour options",
                        children: paintOptions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            onClick: onClickColourOptions,
                            isSquare: true,
                            hasIcon: true,
                            icon: "Palette",
                            size: system/* Size.Large */.$u.Large,
                            theme: system/* Theme.dark */.Q2.dark,
                            hierarchy: Button/* ButtonHierarchy.Filled */.B.Filled,
                            id: "colour-options"
                        })
                    }, "color-options")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Fade */.pT, {
                className: (sticky_buttons_module_default()).right,
                triggerOnce: true,
                delay: 300,
                children: [
                    imageStatus === constants/* constants.imageStatus.EXTERIOR */._G.imageStatus.EXTERIOR && activeSection !== constants/* constants.configPageSections.SPECIFICATION */._G.configPageSections.SPECIFICATION && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (sticky_buttons_module_default()).dashboard,
                        type: "button",
                        onClick: onClickInteriorOption,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleImage/* VehicleImage */.o, {
                            alt: "",
                            className: (sticky_buttons_module_default()).thumbnail,
                            height: 120,
                            width: 172,
                            imagePath: (ref3 = vehicle === null || vehicle === void 0 ? void 0 : (ref2 = vehicle.gallery) === null || ref2 === void 0 ? void 0 : ref2.images.filter(function(i) {
                                return i.angle === "dashboard";
                            })) === null || ref3 === void 0 ? void 0 : ref3[0].path,
                            backupImagePath: "",
                            type: "GALLERY"
                        })
                    }),
                    imageStatus === constants/* constants.imageStatus.INTERIOR */._G.imageStatus.INTERIOR && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        onClick: function() {
                            return setImageStatus(constants/* constants.imageStatus.INTERIOR_FULL_SCREEN */._G.imageStatus.INTERIOR_FULL_SCREEN);
                        },
                        isSquare: true,
                        icon: "Scan",
                        size: system/* Size.Large */.$u.Large,
                        theme: system/* Theme.dark */.Q2.dark,
                        hierarchy: Button/* ButtonHierarchy.Filled */.B.Filled
                    }),
                    imageStatus === constants/* constants.imageStatus.INTERIOR_FULL_SCREEN */._G.imageStatus.INTERIOR_FULL_SCREEN && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        onClick: onClickExteriorOption,
                        isSquare: true,
                        icon: "X",
                        size: system/* Size.Large */.$u.Large,
                        theme: system/* Theme.dark */.Q2.dark,
                        hierarchy: Button/* ButtonHierarchy.Filled */.B.Filled,
                        className: (sticky_buttons_module_default())["position-right"]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Configurator/StickyButtons/index.ts



/***/ }),

/***/ 49870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* reexport */ VehicleImage_VehicleImage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-awesome-reveal/dist/index.js + 1 modules
var dist = __webpack_require__(81277);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/SwitchTransition.js
var SwitchTransition = __webpack_require__(45989);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 3 modules
var CSSTransition = __webpack_require__(76743);
// EXTERNAL MODULE: ./components/styleguide/VehicleImage/index.ts + 2 modules
var VehicleImage = __webpack_require__(52733);
// EXTERNAL MODULE: ./components/styleguide/Configurator/VehicleImage/vehicle-image.module.scss
var vehicle_image_module = __webpack_require__(94248);
var vehicle_image_module_default = /*#__PURE__*/__webpack_require__.n(vehicle_image_module);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./store/selectors/vehicle.js
var selectors_vehicle = __webpack_require__(20548);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/styleguide/Configurator/VehicleImage/VehicleImage.tsx











var VehicleImage_VehicleImage = function(param) {
    var vehicle = param.vehicle, setActiveSection = param.setActiveSection, activeSection = param.activeSection, setActiveImage = param.setActiveImage, activeImage = param.activeImage;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var selectedPaintOption = (0,es/* useSelector */.v9)(selectors_vehicle/* selectSelectedVehiclePaintOption */.KL);
    var paintOptions = (0,es/* useSelector */.v9)(selectors_vehicle/* selectPaintOptions */.eJ);
    var nodeRef = (0,react.useRef)(null);
    var ref6 = (0,react.useRef)(null);
    var ref7 = (0,react.useState)(""), image = ref7[0], setImage = ref7[1];
    var ref8 = (0,react.useState)((ref1 = (ref = vehicle.gallery) === null || ref === void 0 ? void 0 : ref.images.filter(function(img) {
        return img.angle === "sideview";
    })[0]) === null || ref1 === void 0 ? void 0 : ref1.path), defaultImage = ref8[0], setDefaultImage = ref8[1];
    var ref9 = (0,react.useState)(vehicle.images.side), backupImage = ref9[0], setBackupImage = ref9[1];
    var ref10 = (0,react.useState)((ref3 = (ref2 = vehicle.gallery) === null || ref2 === void 0 ? void 0 : ref2.images.filter(function(img) {
        return img.angle === "frontview";
    })[0]) === null || ref3 === void 0 ? void 0 : ref3.path), frontImage = ref10[0], setFrontImage = ref10[1];
    var ref11 = (0,react.useState)((ref5 = (ref4 = vehicle.gallery) === null || ref4 === void 0 ? void 0 : ref4.images.filter(function(img) {
        return img.angle === "rearview";
    })[0]) === null || ref5 === void 0 ? void 0 : ref5.path), rearImage = ref11[0], setRearImage = ref11[1];
    var onImageClick = function() {
        if (setActiveSection) {
            setActiveSection(constants/* constants.configPageSections.GALLERY */._G.configPageSections.GALLERY);
        }
    };
    (0,react.useEffect)(function() {
        if (activeSection === constants/* constants.configPageSections.SPECIFICATION */._G.configPageSections.SPECIFICATION) {
            var ref, ref1, ref2;
            setImage(getImageView((ref = vehicle.gallery) === null || ref === void 0 ? void 0 : ref.images, "sideview"));
            setFrontImage(getImageView((ref1 = vehicle.gallery) === null || ref1 === void 0 ? void 0 : ref1.images, "frontview"));
            setRearImage(getImageView((ref2 = vehicle.gallery) === null || ref2 === void 0 ? void 0 : ref2.images, "rearview"));
        }
    }, [
        activeSection,
        vehicle
    ]);
    var getImageView = function(images, angle) {
        var ref;
        return ((ref = images === null || images === void 0 ? void 0 : images.find(function(img) {
            return img.angle === angle;
        })) === null || ref === void 0 ? void 0 : ref.path) || "";
    };
    (0,react.useEffect)(function() {
        var img;
        var frontImg;
        var rearImg;
        var altImg = vehicle.images.side;
        if (selectedPaintOption && paintOptions.length > 0 && activeSection !== constants/* constants.configPageSections.SPECIFICATION */._G.configPageSections.SPECIFICATION) {
            var doesPaintExistOnNewVehicle = paintOptions.filter(function(color) {
                return color.id === selectedPaintOption.id;
            }).length > 0;
            if (doesPaintExistOnNewVehicle) {
                var ref, ref1, ref2;
                img = getImageView((ref = paintOptions.find(function(color) {
                    return color.id === selectedPaintOption.id;
                })) === null || ref === void 0 ? void 0 : ref.images, "sideview");
                frontImg = getImageView((ref1 = paintOptions.find(function(color) {
                    return color.id === selectedPaintOption.id;
                })) === null || ref1 === void 0 ? void 0 : ref1.images, "frontview");
                rearImg = getImageView((ref2 = paintOptions.find(function(color) {
                    return color.id === selectedPaintOption.id;
                })) === null || ref2 === void 0 ? void 0 : ref2.images, "rearview");
            } else {
                var ref3, ref4, ref5;
                img = getImageView((ref3 = vehicle.gallery) === null || ref3 === void 0 ? void 0 : ref3.images, "sideview");
                frontImg = getImageView((ref4 = vehicle.gallery) === null || ref4 === void 0 ? void 0 : ref4.images, "frontview");
                rearImg = getImageView((ref5 = vehicle.gallery) === null || ref5 === void 0 ? void 0 : ref5.images, "rearview");
            }
        } else {
            var ref6, ref7, ref8;
            img = getImageView((ref6 = vehicle.gallery) === null || ref6 === void 0 ? void 0 : ref6.images, "sideview");
            frontImg = getImageView((ref7 = vehicle.gallery) === null || ref7 === void 0 ? void 0 : ref7.images, "frontview");
            rearImg = getImageView((ref8 = vehicle.gallery) === null || ref8 === void 0 ? void 0 : ref8.images, "rearview");
        }
        setDefaultImage(img);
        setBackupImage(altImg);
        setImage(img);
        setFrontImage(frontImg);
        setRearImage(rearImg);
    }, [
        paintOptions,
        selectedPaintOption,
        vehicle,
        activeSection
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                className: "vehicle-gallery__container ".concat((vehicle_image_module_default()).container),
                triggerOnce: true,
                delay: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((vehicle_image_module_default()).wrapper),
                    "data-active-section": activeSection === null || activeSection === void 0 ? void 0 : activeSection.toLowerCase(),
                    ref: ref6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((vehicle_image_module_default()).carousel),
                        ref: ref6,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchTransition/* default */.Z, {
                                mode: "in-out",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
                                    classNames: {
                                        enter: (vehicle_image_module_default()).enter,
                                        enterActive: (vehicle_image_module_default())["enter--active"],
                                        enterDone: (vehicle_image_module_default())["enter--done"],
                                        exit: (vehicle_image_module_default()).exit,
                                        exitActive: (vehicle_image_module_default())["exit--active"],
                                        exitDone: (vehicle_image_module_default())["exit--done"]
                                    },
                                    timeout: 1500,
                                    nodeRef: nodeRef,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (vehicle_image_module_default()).item,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (vehicle_image_module_default()).content,
                                            onClick: onImageClick,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleImage/* VehicleImage */.o, {
                                                imagePath: image,
                                                backupImagePath: backupImage,
                                                alt: "".concat(vehicle.manufacturerName, " ").concat(vehicle.modelName),
                                                height: 800,
                                                width: 1200,
                                                priority: true,
                                                quality: 90,
                                                type: "DEFAULT"
                                            }, defaultImage)
                                        })
                                    })
                                }, image)
                            }),
                            !!frontImage && activeSection === constants/* constants.configPageSections.SPECIFICATION */._G.configPageSections.SPECIFICATION && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((vehicle_image_module_default()).item, " ").concat((vehicle_image_module_default()).scaled, " ").concat((vehicle_image_module_default()).centered),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (vehicle_image_module_default()).content,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleImage/* VehicleImage */.o, {
                                                imagePath: frontImage,
                                                backupImagePath: "",
                                                alt: "".concat(vehicle.manufacturerName, " ").concat(vehicle.modelName),
                                                height: 800,
                                                width: 1200,
                                                priority: true,
                                                quality: 90,
                                                type: "DEFAULT"
                                            }, frontImage)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((vehicle_image_module_default()).item, " ").concat((vehicle_image_module_default()).scaled, " ").concat((vehicle_image_module_default()).centered),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (vehicle_image_module_default()).content,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleImage/* VehicleImage */.o, {
                                                imagePath: rearImage,
                                                backupImagePath: "",
                                                alt: "".concat(vehicle.manufacturerName, " ").concat(vehicle.modelName),
                                                height: 800,
                                                width: 1200,
                                                priority: true,
                                                quality: 90,
                                                type: "DEFAULT"
                                            }, rearImage)
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            !!frontImage && activeSection === constants/* constants.configPageSections.SPECIFICATION */._G.configPageSections.SPECIFICATION && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (vehicle_image_module_default()).arrows,
                "data-navigation-position": activeImage === "sideview" ? "start" : activeImage === "rearview" ? "end" : "middle",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        onClick: function() {
                            setActiveImage(activeImage === "sideview" ? "rearview" : activeImage === "rearview" ? "frontview" : "sideview");
                            if (activeImage === "sideview") {
                                var ref;
                                ref6 === null || ref6 === void 0 ? void 0 : (ref = ref6.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
                                    left: 100000,
                                    behavior: "smooth"
                                });
                            } else {
                                var ref1, ref2, ref3;
                                ref6 === null || ref6 === void 0 ? void 0 : (ref1 = ref6.current) === null || ref1 === void 0 ? void 0 : ref1.scrollTo({
                                    left: ref6.current.scrollLeft - ((ref3 = ref6 === null || ref6 === void 0 ? void 0 : (ref2 = ref6.current) === null || ref2 === void 0 ? void 0 : ref2.children[0]) === null || ref3 === void 0 ? void 0 : ref3.clientWidth),
                                    behavior: "smooth"
                                });
                            }
                        },
                        icon: "ChevronLeft",
                        size: system/* Size.ExtraSmall */.$u.ExtraSmall,
                        hierarchy: Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray,
                        theme: system/* Theme.light */.Q2.light
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        onClick: function() {
                            setActiveImage(activeImage === "sideview" ? "frontview" : activeImage === "frontview" ? "rearview" : "sideview");
                            if (activeImage === "rearview") {
                                var ref;
                                ref6 === null || ref6 === void 0 ? void 0 : (ref = ref6.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
                                    left: 0,
                                    behavior: "smooth"
                                });
                            } else {
                                var ref1, ref2, ref3;
                                ref6 === null || ref6 === void 0 ? void 0 : (ref1 = ref6.current) === null || ref1 === void 0 ? void 0 : ref1.scrollTo({
                                    left: ref6.current.scrollLeft + ((ref3 = ref6 === null || ref6 === void 0 ? void 0 : (ref2 = ref6.current) === null || ref2 === void 0 ? void 0 : ref2.children[0]) === null || ref3 === void 0 ? void 0 : ref3.clientWidth),
                                    behavior: "smooth"
                                });
                            }
                        },
                        theme: system/* Theme.light */.Q2.light,
                        icon: "ChevronRight",
                        size: system/* Size.ExtraSmall */.$u.ExtraSmall,
                        hierarchy: Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Configurator/VehicleImage/index.tsx



/***/ }),

/***/ 84312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ VehicleView; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-awesome-reveal/dist/index.js + 1 modules
var dist = __webpack_require__(81277);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/styleguide/Configurator/VehicleImage/index.tsx + 1 modules
var VehicleImage = __webpack_require__(49870);
// EXTERNAL MODULE: ./components/styleguide/Configurator/VehicleView/vehicle-view.module.scss
var vehicle_view_module = __webpack_require__(84821);
var vehicle_view_module_default = /*#__PURE__*/__webpack_require__.n(vehicle_view_module);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./components/views/ConfigPage/ColourOptions/ColourOptionsAlert.tsx
var ColourOptionsAlert = __webpack_require__(1368);
// EXTERNAL MODULE: ./components/styleguide/Configurator/Dimensions/dimensions.module.scss
var dimensions_module = __webpack_require__(58353);
var dimensions_module_default = /*#__PURE__*/__webpack_require__.n(dimensions_module);
// EXTERNAL MODULE: ./lib/utilities/search.js
var search = __webpack_require__(45425);
;// CONCATENATED MODULE: ./components/styleguide/Configurator/Dimensions/Dimensions.tsx




var Dimensions = function(param) {
    var activeImage = param.activeImage, technicalData = param.technicalData, vehicleType = param.vehicleType;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var sizeDataPoints = [
        {
            metric: "mm",
            value: ((ref = technicalData[4]) === null || ref === void 0 ? void 0 : ref.displayValue) !== "N" ? (0,search/* formatWithCommas */.b1)(Number((ref1 = technicalData[4]) === null || ref1 === void 0 ? void 0 : ref1.displayValue)) : "---",
            label: "Length"
        },
        {
            metric: "mm",
            value: ((ref2 = technicalData[5]) === null || ref2 === void 0 ? void 0 : ref2.displayValue) && ((ref3 = technicalData[5]) === null || ref3 === void 0 ? void 0 : ref3.displayValue) !== "N" ? (0,search/* formatWithCommas */.b1)(Number((ref4 = technicalData[5]) === null || ref4 === void 0 ? void 0 : ref4.displayValue)) : ((ref5 = technicalData[33]) === null || ref5 === void 0 ? void 0 : ref5.displayValue) && ((ref6 = technicalData[33]) === null || ref6 === void 0 ? void 0 : ref6.displayValue) !== "N" ? (0,search/* formatWithCommas */.b1)(Number(technicalData[33].displayValue)) : "---",
            label: "Width"
        },
        {
            metric: "mm",
            value: ((ref7 = technicalData[15]) === null || ref7 === void 0 ? void 0 : ref7.displayValue) && ((ref8 = technicalData[15]) === null || ref8 === void 0 ? void 0 : ref8.displayValue) !== "N" ? (0,search/* formatWithCommas */.b1)(Number((ref9 = technicalData[15]) === null || ref9 === void 0 ? void 0 : ref9.displayValue)) : "---",
            label: "Wheelbase"
        },
        {
            metric: "mm",
            value: ((ref10 = technicalData[34]) === null || ref10 === void 0 ? void 0 : ref10.displayValue) && ((ref11 = technicalData[34]) === null || ref11 === void 0 ? void 0 : ref11.displayValue) !== "N" ? (0,search/* formatWithCommas */.b1)(Number((ref12 = technicalData[34]) === null || ref12 === void 0 ? void 0 : ref12.displayValue)) : ((ref13 = technicalData[35]) === null || ref13 === void 0 ? void 0 : ref13.displayValue) && ((ref14 = technicalData[35]) === null || ref14 === void 0 ? void 0 : ref14.displayValue) !== "N" ? (0,search/* formatWithCommas */.b1)(Number(technicalData[35].displayValue)) : "---",
            label: "Height"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            activeImage === "sideview" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    vehicleType === constants/* FILTER_VEHICLE_TYPES_VANS */.Bz && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((dimensions_module_default()).dimensions, " ").concat((dimensions_module_default()).wheelbase),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                sizeDataPoints.filter(function(item) {
                                    return item.label === "Wheelbase";
                                })[0].value,
                                "mm"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((dimensions_module_default()).dimensions, " ").concat((dimensions_module_default()).length, " ").concat(vehicleType === constants/* FILTER_VEHICLE_TYPES_VANS */.Bz ? (dimensions_module_default())["with-wheelbase"] : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                sizeDataPoints.filter(function(item) {
                                    return item.label === "Length";
                                })[0].value,
                                "mm"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((dimensions_module_default()).dimensions, " ").concat((dimensions_module_default()).height),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        sizeDataPoints.filter(function(item) {
                            return item.label === "Height";
                        })[0].value,
                        "mm"
                    ]
                })
            }),
            activeImage !== "sideview" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((dimensions_module_default()).dimensions, " ").concat((dimensions_module_default()).width),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        sizeDataPoints.filter(function(item) {
                            return item.label === "Width";
                        })[0].value,
                        "mm"
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Configurator/Dimensions/index.ts


// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
;// CONCATENATED MODULE: ./components/styleguide/Configurator/VehicleView/VehicleView.tsx











var VehicleDataSpotlightGroup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5547).then(__webpack_require__.bind(__webpack_require__, 25547));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25547)
            ];
        }
    }
});
var Icon = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(6244)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    },
    ssr: false
});
var VehicleView = function(param) {
    var vehicle = param.vehicle, technicalData = param.technicalData, setActiveSection = param.setActiveSection, activeSection = param.activeSection;
    var ref = (0,react.useState)("sideview"), activeImage = ref[0], setActiveImage = ref[1];
    var onScrollDownClick = function() {
        var specBody = document.getElementById("specification-body");
        specBody === null || specBody === void 0 ? void 0 : specBody.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (vehicle_view_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleImage/* VehicleImage */.o, {
                vehicle: vehicle,
                setActiveSection: setActiveSection,
                activeSection: activeSection,
                setActiveImage: setActiveImage,
                activeImage: activeImage
            }),
            activeSection === constants/* constants.configPageSections.COLOUR_OPTIONS */._G.configPageSections.COLOUR_OPTIONS && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                className: (vehicle_view_module_default()).banner,
                triggerOnce: true,
                delay: 300,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColourOptionsAlert/* ColourOptionsAlert */.W, {})
            }),
            activeSection === constants/* constants.configPageSections.SPECIFICATION */._G.configPageSections.SPECIFICATION && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Fade */.pT, {
                triggerOnce: true,
                delay: 300,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (vehicle_view_module_default()).scroll,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                            onClick: onScrollDownClick,
                            hasBackground: false,
                            hasPadding: false,
                            hierarchy: Button/* ButtonHierarchy.Text */.B.Text,
                            size: system/* Size.Medium */.$u.Medium,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                    name: "MoveDown",
                                    size: system/* Size.Medium */.$u.Medium
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "Scroll",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "down"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dimensions, {
                        activeImage: activeImage,
                        technicalData: technicalData,
                        vehicleType: vehicle.type
                    })
                ]
            }),
            activeSection === constants/* constants.configPageSections.OVERVIEW */._G.configPageSections.OVERVIEW && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                className: (vehicle_view_module_default()).spotlight,
                triggerOnce: true,
                delay: 300,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleDataSpotlightGroup, {
                    technicalData: technicalData,
                    vehicleFuelType: vehicle.fuelType,
                    vehicleType: vehicle.type
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Configurator/VehicleView/index.tsx



/***/ }),

/***/ 1368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ ColourOptionsAlert; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _colour_options_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39536);
/* harmony import */ var _colour_options_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_colour_options_module_scss__WEBPACK_IMPORTED_MODULE_1__);


var ColourOptionsAlert = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_colour_options_module_scss__WEBPACK_IMPORTED_MODULE_1___default().information),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                        children: "Important: "
                    }),
                    "Colour options subject to availability and may carry an additional cost"
                ]
            })
        })
    });
};


/***/ }),

/***/ 58353:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dimensions":"dimensions_dimensions__3w_84","length":"dimensions_length__aLGFj","with-wheelbase":"dimensions_with-wheelbase__218N4","width":"dimensions_width__YaBVD","wheelbase":"dimensions_wheelbase__Zax2I","height":"dimensions_height__PNJ96","phAnimation":"dimensions_phAnimation__a6QOZ"};

/***/ }),

/***/ 54047:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sticky-buttons":"sticky-buttons_sticky-buttons__gTK3E","left":"sticky-buttons_left__DcLpJ","right":"sticky-buttons_right__7KDjW","button":"sticky-buttons_button__Q36f_","tooltip":"sticky-buttons_tooltip__LxSuH","tooltip-arrow":"sticky-buttons_tooltip-arrow__F1b6G","sideview":"sticky-buttons_sideview__EfwwB","dashboard":"sticky-buttons_dashboard__etmQ2","thumbnail":"sticky-buttons_thumbnail__pcXLC","halo":"sticky-buttons_halo__i_5lQ","phAnimation":"sticky-buttons_phAnimation__ThaRP"};

/***/ }),

/***/ 94248:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vehicle-image_wrapper__dZp7j","carousel":"vehicle-image_carousel__NDaBO","item":"vehicle-image_item__eXukV","scaled":"vehicle-image_scaled__vGcIo","centered":"vehicle-image_centered__PUJZv","content":"vehicle-image_content__AOwKO","container":"vehicle-image_container__SMmL3","arrows":"vehicle-image_arrows__6TKJh","hidden":"vehicle-image_hidden__mY_nJ","enter":"vehicle-image_enter___B6MU","exit":"vehicle-image_exit____eT6","enter--active":"vehicle-image_enter--active__Q_DgO","exit--active":"vehicle-image_exit--active__MzSIZ","exit--done":"vehicle-image_exit--done__OcN97","phAnimation":"vehicle-image_phAnimation__atTDq"};

/***/ }),

/***/ 84821:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"vehicle-view_container__1GFgW","spotlight":"vehicle-view_spotlight__AVzZ4","hidden":"vehicle-view_hidden__Nht3m","banner":"vehicle-view_banner__JuZl6","scroll":"vehicle-view_scroll__hKNI1","phAnimation":"vehicle-view_phAnimation__mURxr"};

/***/ }),

/***/ 39536:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"information":"colour-options_information__4w__D","type":"colour-options_type__u8a1k","active":"colour-options_active__ke6YP","option":"colour-options_option__mT2iF","option-outer":"colour-options_option-outer__5kjcn","is-selected":"colour-options_is-selected__j2Eb1","disabled":"colour-options_disabled__NRfbx","check":"colour-options_check__lpdnL","list":"colour-options_list__AKVQ9","title":"colour-options_title__hA1ur","subtitle":"colour-options_subtitle__J1CIm","wrapper":"colour-options_wrapper__4z_Za","list-wrapper":"colour-options_list-wrapper__muNmr","head":"colour-options_head__3hCca","container":"colour-options_container__T4TXS","phAnimation":"colour-options_phAnimation__swmob"};

/***/ })

}]);